import React, { useState } from 'react';
import { Profile } from '@atlaskit/atlassian-navigation';
import Avatar, { AvatarItem, SizeType } from '@atlaskit/avatar';
import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';
import { ButtonItem, MenuGroup, Section } from '@atlaskit/menu';
import Popup from '@atlaskit/popup';
import { N80, N200 } from '@atlaskit/theme/colors';
import { useApplicationContext } from '@css-xp/base/common-context';
import { handlePPCLogout, handlePPCSwitchAccountClick, handlePPCUserProfileClick } from '@css-xp/ppc-utils';
import './profile-button.scss';

const ProfileAvatar = ({
  picture,
  size,
  testIdPrefix,
}: {
  picture: string;
  size?: SizeType;
  testIdPrefix?: string;
}) => {
  if (picture) {
    return (
      <Avatar
        size={size ? size : 'small'}
        src={picture}
        testId={testIdPrefix ? `${testIdPrefix}-avatar-image-${picture}` : `avatar-image-${picture}`}
      />
    );
  }
  return <Avatar size={size ? size : 'small'} borderColor={N80} />;
};

const ProfileContent = () => {
  const user = useApplicationContext();

  return (
    <MenuGroup>
      <Section title="Account">
        <div className="ppc-profile-section-item">
          <AvatarItem
            avatar={<ProfileAvatar picture={user?.picture} size="medium"></ProfileAvatar>}
            primaryText={user?.displayName || 'Unknown'}
            secondaryText={user?.email}
          />
        </div>
      </Section>
      <Section hasSeparator>
        <ButtonItem
          onClick={() => {
            handlePPCSwitchAccountClick();
          }}
          testId="switch-account-button"
        >
          Switch account
        </ButtonItem>
        <ButtonItem
          onClick={() => {
            handlePPCUserProfileClick(user.email);
          }}
          testId="your-profile-button"
          iconAfter={<ShortcutIcon primaryColor={N200} label="" size="small" />}
        >
          Your Profile
        </ButtonItem>
        <ButtonItem
          onClick={() => {
            handlePPCLogout();
          }}
          testId="logout-button"
        >
          Log out
        </ButtonItem>
      </Section>
    </MenuGroup>
  );
};

export const ProfileButton = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const user = useApplicationContext();

  return (
    <Popup
      content={ProfileContent}
      testId="profile-avatar-popover"
      isOpen={showDropdown}
      placement="bottom-end"
      onClose={() => setShowDropdown(false)}
      trigger={(triggerProps) => (
        <Profile
          // Important to pass `triggerProps`, otherwise positioning, etc. are not calculated correctly
          {...triggerProps}
          icon={<ProfileAvatar picture={user?.picture} testIdPrefix="popover"></ProfileAvatar>}
          onClick={() => setShowDropdown((prev) => !prev)}
          tooltip="Your profile and settings"
          testId="profile-avatar-trigger"
        />
      )}
    />
  );
};
